<div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">

  <div
    class="w-[450px] max-w-[90vw] rounded-2xl bg-white border border-slate-200 p-8 shadow-2xl"
    role="dialog"
    aria-labelledby="session-timeout-title"
    aria-describedby="session-timeout-desc">

    <!-- Icon -->
    <div class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
      <svg class="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4l3 3M12 2a10 10 0 100 20 10 10 0 000-20z" />
      </svg>
    </div>

    <!-- Title -->
    <h1
      id="session-timeout-title"
      class="mt-5 text-center text-2xl font-bold text-slate-800">
      Session Timeout
    </h1>

    <!-- Message -->
    <p [innerHTML]="reasonText"></p>

    <!-- Countdown -->
    <div class="mt-6 rounded-xl bg-slate-100 border border-slate-200 p-4 text-center">
      <p class="text-xs font-medium uppercase tracking-widest text-slate-500">
        Time Remaining
      </p>

      <p class="mt-2 text-4xl font-bold text-red-600">
        {{ displayTime }}
      </p>
    </div>

    <!-- Buttons -->
    <div class="mt-8 flex justify-center gap-4">

      <button
        class="rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition"
        (click)="continueSession()">
        Continue
      </button>

      <button
        class="rounded-lg border border-slate-300 bg-white px-6 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-100 transition"
        (click)="logout()">
        Log out
      </button>
      
    </div>
  </div>
</div>